import { c as _c } from "react/compiler-runtime";
import { CheckCircleSolid } from '@byway/icons';
import clsx from 'clsx';
import { ToggleButton as RACToggleButton } from 'react-aria-components';
import styles from './ToggleButton.module.css';
import type { ToggleButtonProps } from './ToggleButton.types';
export function ToggleButton(t0) {
  const $ = _c(15);
  let isElevated;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      isElevated,
      showToggleIndicator: t1,
      variant: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isElevated;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    isElevated = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const showToggleIndicator = t1 === undefined ? true : t1;
  const variant = t2 === undefined ? "default" : t2;
  const t3 = variant === "pill";
  let t4;
  if ($[5] !== isElevated || $[6] !== t3) {
    t4 = clsx(styles.toggleButton, {
      [styles.isElevated]: isElevated,
      [styles.pill]: t3
    });
    $[5] = isElevated;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props.children || $[9] !== showToggleIndicator) {
    t5 = renderProps => {
      const isSelected = renderProps.state.isSelected;
      return <>{showToggleIndicator && <div className={styles.circleContainer}>{isSelected ? <CheckCircleSolid size="scale" decorative={true} /> : <div className={styles.emptyCircle} />}</div>}{props.children}</>;
    };
    $[8] = props.children;
    $[9] = showToggleIndicator;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== props || $[12] !== t4 || $[13] !== t5) {
    t6 = <RACToggleButton className={t4} {...props}>{t5}</RACToggleButton>;
    $[11] = props;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}